import React from 'react'
import PropTypes from 'prop-types'
import { format } from 'date-fns'
import { Link } from 'react-router-dom'
import { Text, Margin } from 'shared/components'
import { InWinImage } from 'routes/shared/components'
import { event } from 'routes/route.map'
import CustomIcon from 'shared/components/customIcon'

import * as styles from './styles'

const getSportIcon = (sportType) => {
	const sportIcons = {
		'BASKETBALL': 'sports/Bascketball',
		'BASEBALL': 'sports/Baseball',
		'SOCCER': 'sports/Soccer',
		'HOCKEY': 'sports/Hockey',
		'FOOTBALL': 'sports/Football',
		'FOOTBALL_NZ': 'sports/Rugby',
		'ATHLETICS': 'event',
		'OTHER': 'event'
	}

	return sportIcons[sportType?.toUpperCase()] || 'event'
}

const formatDateRange = (startTime, endTime) => {
	if (!startTime) return ''

	const startDate = new Date(startTime)
	const endDate = endTime ? new Date(endTime) : null

	if (endDate) {
		// If both dates exist, show range
		return `${format(startDate, 'MMM d, yyyy')} - ${format(endDate, 'MMM d, yyyy')}`
	} else {
		// If only start date, show just that
		return format(startDate, 'MMM d, yyyy')
	}
}

const MobileTournamentCardComponent = ({ event: eventData }) => {
	// Handle both event data (with nested tournament) and direct tournament data
	const isDirectTournament = eventData.tournamentName !== undefined

	if (isDirectTournament) {
		// Direct tournament data from tournaments API
		const { id, tournamentName, sportType, startTime, endTime, logo } = eventData
		const displayName = tournamentName || 'Tournament'
		const tournamentLogo = logo
		const dateRange = formatDateRange(startTime, endTime)

		return (
			<Link to={event.view(id)} css={styles.cardLink}>
				<div css={styles.card}>
					<div css={styles.cardContent}>
						<div css={styles.leftSection}>
							<div css={styles.logoContainer}>
								{tournamentLogo ? (
									<InWinImage
										source={tournamentLogo}
										alt={displayName}
										css={styles.tournamentLogo}
									/>
								) : (
									<CustomIcon
										icon={getSportIcon(sportType)}
										style={styles.sportIcon}
									/>
								)}
							</div>
							<div css={styles.tournamentInfo}>
								<Text size={13} bold css={styles.tournamentName}>
									{displayName}
								</Text>
								<Text size={8} css={styles.dateRange}>
									{dateRange}
								</Text>
							</div>
						</div>

						<div css={styles.rightSection}>
							<CustomIcon
								icon="angle-right"
								style={styles.arrowIcon}
							/>
						</div>
					</div>
				</div>
			</Link>
		)
	}

	// Original event data structure (fallback)
	const { id, tournament, startTime, endTime, name: eventName } = eventData
	const sportType = tournament?.sportType
	const displayName = eventName || tournament?.tournamentName || 'Event'
	const tournamentLogo = tournament?.logo
	const dateRange = formatDateRange(startTime, endTime)

	return (
		<Link to={event.view(id)} css={styles.cardLink}>
			<div css={styles.card}>
				<div css={styles.cardContent}>
					<div css={styles.leftSection}>
						<div css={styles.logoContainer}>
							{tournamentLogo ? (
								<InWinImage
									source={tournamentLogo}
									alt={displayName}
									css={styles.tournamentLogo}
								/>
							) : (
								<CustomIcon
									icon={getSportIcon(sportType)}
									style={styles.sportIcon}
								/>
							)}
						</div>
						<div css={styles.tournamentInfo}>
							<Text size={13} bold css={styles.tournamentName}>
								{displayName}
							</Text>
							<Text size={8} css={styles.dateRange}>
								{dateRange}
							</Text>
						</div>
					</div>

					<div css={styles.rightSection}>
						<CustomIcon
							icon="angle-right"
							style={styles.arrowIcon}
						/>
					</div>
				</div>
			</div>
		</Link>
	)
}

MobileTournamentCardComponent.propTypes = {
	event: PropTypes.shape({
		id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
		// Direct tournament data (from tournaments API)
		tournamentName: PropTypes.string,
		sportType: PropTypes.string,
		logo: PropTypes.string,
		// Event data with nested tournament (fallback)
		name: PropTypes.string,
		tournament: PropTypes.shape({
			tournamentName: PropTypes.string,
			sportType: PropTypes.string,
			logo: PropTypes.string,
		}),
		startTime: PropTypes.string,
		endTime: PropTypes.string,
	}).isRequired,
}

export default MobileTournamentCardComponent 